import { useEffect, useState } from "react";
import { Menu, X, ChevronUp } from "lucide-react";

const ITEMS = [
  { id: "top", label: "Home" },
  { id: "capabilities", label: "Capabilities" },
  { id: "applications", label: "Applications" },
  { id: "quality", label: "Quality" },
  { id: "about", label: "About" },
  { id: "contact", label: "Contact" },
];

const scrollTo = (id) => {
  const el = document.getElementById(id) || document.querySelector(id === "top" ? "#top" : `#${id}`);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: id === "top" ? 0 : -90 });
  else el.scrollIntoView({ behavior: "smooth" });
};

// Persistent bottom-centered navigation; assistant sits bottom-left, call button bottom-right.
export const BottomNav = () => {
  const [active, setActive] = useState("top");
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((en) => {
          if (en.isIntersecting) setActive(en.target.id);
        });
      },
      { rootMargin: "-40% 0px -55% 0px" }
    );
    ITEMS.forEach(({ id }) => {
      const el = document.getElementById(id);
      if (el) io.observe(el);
    });
    return () => io.disconnect();
  }, []);

  const go = (id) => (e) => {
    e.preventDefault();
    setOpen(false);
    scrollTo(id);
  };

  return (
    <nav data-testid="bottom-nav" className="nav-pill" aria-label="Primary">
      <button
        type="button"
        className="md:hidden !px-3"
        onClick={() => setOpen((v) => !v)}
        data-testid="bottom-nav-menu"
        aria-expanded={open}
        aria-label="Open navigation menu"
      >
        {open ? <X className="h-4 w-4" /> : <Menu className="h-4 w-4" />}
      </button>
      <div className={`${open ? "flex" : "hidden"} absolute bottom-[calc(100%+0.5rem)] left-1/2 -translate-x-1/2 flex-col rounded-2xl border border-white/10 bg-[#0b0e13]/95 p-2 backdrop-blur-xl md:static md:left-auto md:flex md:flex-row md:translate-x-0 md:rounded-full md:border-0 md:bg-transparent md:p-0 md:backdrop-blur-none`}>
        {ITEMS.map(({ id, label }) => (
          <a
            key={id}
            href={`#${id}`}
            onClick={go(id)}
            data-testid={`bottom-nav-${id}`}
            className={id === "top" ? "hidden md:inline-flex" : `${active === id ? "active" : ""} text-center`}
          >
            {label}
          </a>
        ))}
        <a href="#contact" onClick={go("contact")} data-testid="bottom-nav-quote" className="nav-cta hidden md:inline-flex">
          Request a Quote
        </a>
      </div>
      <a
        href="#contact"
        onClick={go("contact")}
        data-testid="bottom-nav-quote-mobile"
        className="nav-cta md:hidden !px-3.5 flex items-center gap-1.5"
      >
        Quote
      </a>
      <span className="hidden"><ChevronUp className="h-4 w-4" /></span>
    </nav>
  );
};
